import PropTypes from 'prop-types';

export const paginationProps = {
  totalPages: PropTypes.number.isRequired,
};

export const paginationType = PropTypes.shape({ ...paginationProps });
